import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import DangerBox from 'components/Indoor_Cameras/IN-8815_QFHD/Video_Streaming/DangerBox';
import PrimaryBox from 'components/Indoor_Cameras/IN-8815_QFHD/Video_Streaming/PrimaryBox';
import NavButtons from 'components/Indoor_Cameras/IN-8815_QFHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import VideoFormats from 'components/Products/Usermanuals/YoutubeVideoStreamingFormats';
export const _frontmatter = {
  "title": "IN-8815 4K QFHD Video Streaming",
  "path": "/Innenkameras/IN-8815_QFHD/Video_Streaming/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die IN-8815 4K QFHD ist die erste INSTAR Kamera mit dem neuen 2160p Chipsatz.",
  "image": "./P_SearchThumb_IN-8815QFHD_Video_Streaming.webp",
  "social": "/images/Search/P_SearchThumb_IN-8815QFHD_Video_Streaming.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-8415WQHD_white.webp",
  "chapter": "Indoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='IN-8815 4K QFHD' dateChanged='2017-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die IN-8815 4K QFHD ist die erste INSTAR Kamera mit dem neuen 2160p Chipsatz.' image='/images/Search/P_SearchThumb_IN-8815QFHD_Video_Streaming.webp' twitter='/images/Search/P_SearchThumb_IN-8815QFHD_Video_Streaming.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Indoor_Cameras/IN-8815_QFHD/Video_Streaming/' locationFR='/fr/Indoor_Cameras/IN-8815_QFHD/Video_Streaming/' crumbLabel="Streaming" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-8815-4k-qfhd-handbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-8815-4k-qfhd-handbuch",
        "aria-label": "in 8815 4k qfhd handbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8815 4K QFHD Handbuch`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoFormats mdxType="VideoFormats" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Ihre Kamera stellt Ihnen 3 unabhängige Videostreams zur Verfügung die mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`11`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`12`}</code>{` und `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`13`}</code>{` benannt sind. Die 3 Streams haben standardmäßig die folgenden Auflösungen:`}</p>
    <ul>
      <li parentName="ul">{`Kanal `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`11`}</code>{`: `}<strong parentName="li">{`2160p`}</strong>{` (3840 × 2160 Pixel ~ 8.29MP)`}</li>
      <li parentName="ul">{`Kanal `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`12`}</code>{`: `}<strong parentName="li">{`1080p`}</strong>{` (1920x1080 Pixel ~ 2.1MP)`}</li>
      <li parentName="ul">{`Kanal `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`13`}</code>{`: `}<strong parentName="li">{`360p`}</strong>{` (640x360 Pixel ~ 0.2MP)`}</li>
    </ul>
    <h3 {...{
      "id": "rtsp-streaming",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#rtsp-streaming",
        "aria-label": "rtsp streaming permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`RTSP Streaming`}</h3>
    <p><em parentName="p">{`z.B.`}</em>{` `}<Link to="/Software/Windows/VLC_Player/" mdxType="Link">{`VLC Player`}</Link></p>
    <p>{`Um Ihre Kamera mit Software eines Drittanbieters zu nutzen, müssen Sie teilweise eine bestimmte URL (Webadresse) eingeben unter welcher Ihre Kamera verfügbar ist. Das Programm kann dann direkt auf das Videobild Ihrer Kamera zugreifen. Schritt-für-Schritt Anleitungen für die wichtigsten Programme finden Sie auf `}<Link to="/Software/" mdxType="Link">{`hier`}</Link>{` here.`}</p>
    <h3 {...{
      "id": "zugriff-im-internen-netzwerk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zugriff-im-internen-netzwerk",
        "aria-label": "zugriff im internen netzwerk permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zugriff im internen Netzwerk`}</h3>
    <p>{`Bitte nutzen Sie den folgenden Pfad um Ihre Kamera mit Drittsoftware zu nutzen:`}</p>
    <ul>
      <li parentName="ul">{`RTSP Stream Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rtsp://user:password@192.168.x.x:xxx/livestream/11`}</code></li>
      <li parentName="ul">{`RTSP Stream Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rtsp://user:password@192.168.x.x:xxx/livestream/12`}</code></li>
      <li parentName="ul">{`RTSP Stream Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rtsp://user:password@192.168.x.x:xxx/livestream/13`}</code></li>
    </ul>
    <p><em parentName="p">{`Bei dem Benutzer und Passwort handelt es sich um Ihre Login-Daten zur Kamera - z.B.`}</em>{` `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`rtsp://admin:instar@192.168.1.25:554/livestream/11`}</code></p>
    <p>{`Ergänzen Sie bitte die “x” entsprechend der IP Ihrer Kamera (z.B. bei der Fritzbox ist das erste x = 178 und das zweite x = ist die EndIP die Ihre Kamera von Ihrem Router erhält). Sollten Sie den RTSP Port unter 5.2.1 geändert haben (`}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/"
      }}>{`Standard = 554`}</a>{`), muss entsprechend dieser noch mit einem Doppelpunkt an die IP Adresse gehangen werden.`}</p>
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "zugriff-über-das-internet",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zugriff-%C3%BCber-das-internet",
        "aria-label": "zugriff über das internet permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zugriff über das Internet`}</h3>
    <p>{`Für den Fernzugriff auf die Kamera können Sie folgende `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/Fernzugriff/"
      }}>{`DDNS Adresse`}</a>{` verwenden:`}</p>
    <ul>
      <li parentName="ul">{`RTSP Stream 1: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rtsp://user:password@xxxx.ddns-instar.de:554/livestream/11`}</code></li>
    </ul>
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "mjpeg--jpg-streaming",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#mjpeg--jpg-streaming",
        "aria-label": "mjpeg  jpg streaming permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MJPEG / JPG Streaming`}</h2>
    <p>{`Um Ihre Kamera mit Software eines Drittanbieters zu nutzen, müssen Sie teilweise eine bestimmte URL (Webadresse) eingeben unter welcher Ihre Kamera verfügbar ist. Das Programm kann dann direkt auf das Videobild Ihrer Kamera zugreifen. Schritt-für-Schritt Anleitungen für die wichtigsten Programme finden Sie `}<a parentName="p" {...{
        "href": "/de/Software/"
      }}>{`hier`}</a>{`.`}</p>
    <h3 {...{
      "id": "zugriff-im-internen-netzwerk-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zugriff-im-internen-netzwerk-1",
        "aria-label": "zugriff im internen netzwerk 1 permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zugriff im internen Netzwerk`}</h3>
    <p>{`Bitte nutzen Sie den folgenden Pfad um Ihre Kamera mit Drittsoftware zu nutzen:`}</p>
    <h4 {...{
      "id": "video",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#video",
        "aria-label": "video permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Video`}</h4>
    <ul>
      <li parentName="ul">{`MJPEG Pfad Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/11?action=play&media=mjpeg&user=Benutzer&pwd=Kennwort`}</code></li>
      <li parentName="ul">{`MJPEG Pfad Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/12?action=play&media=mjpeg&user=Benutzer&pwd=Kennwort`}</code></li>
      <li parentName="ul">{`MJPEG Pfad Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/13?action=play&media=mjpeg&user=Benutzer&pwd=Kennwort`}</code></li>
    </ul>
    <p><strong parentName="p">{`Oder`}</strong></p>
    <ul>
      <li parentName="ul">{`MJPEG Pfad Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/11?action=play&media=mjpeg`}</code></li>
      <li parentName="ul">{`MJPEG Pfad Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/12?action=play&media=mjpeg`}</code></li>
      <li parentName="ul">{`MJPEG Pfad Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/13?action=play&media=mjpeg`}</code></li>
    </ul>
    <p><strong parentName="p">{`Oder auch als MP4:`}</strong></p>
    <ul>
      <li parentName="ul">{`Fragmented MP4 Pfad Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/11?action=play&media=fmp4`}</code></li>
      <li parentName="ul">{`Fragmented MP4 Pfad Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/12?action=play&media=fmp4`}</code></li>
      <li parentName="ul">{`Fragmented MP4 Pfad Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/livestream/13?action=play&media=fmp4`}</code></li>
    </ul>
    <h4 {...{
      "id": "snapshot",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#snapshot",
        "aria-label": "snapshot permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Snapshot`}</h4>
    <ul>
      <li parentName="ul">{`JPG Pfad Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://192.168.x.x/snap.cgi?chn=11&user=Benutzer&pwd=Kennwort`}</code></li>
      <li parentName="ul">{`JPG Pfad Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://192.168.x.x/snap.cgi?chn=12&user=Benutzer&pwd=Kennwort`}</code></li>
      <li parentName="ul">{`JPG Pfad Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://192.168.x.x/snap.cgi?chn=13&user=Benutzer&pwd=Kennwort`}</code></li>
    </ul>
    <p><strong parentName="p">{`Oder`}</strong></p>
    <ul>
      <li parentName="ul">{`JPG Pfad Kanal 11: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/snap.cgi?chn=11`}</code></li>
      <li parentName="ul">{`JPG Pfad Kanal 12: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/snap.cgi?chn=12`}</code></li>
      <li parentName="ul">{`JPG Pfad Kanal 13: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`http://Benutzer:Kennwort@192.168.x.x/snap.cgi?chn=13`}</code></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      